import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { feeEngineEndpoints } from "@/features/fee-engine/api/endpoints";
import type {
  PromotionDto,
  PromotionFilter,
} from "@/features/fee-engine/api/dto";

/** Liste paginée des promotions (`POST /Promotions/all`, guide §4.2). */
export const usePromotions = (
  params: ListRequest<PromotionFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.FEE_PROMOTIONS_LIST(params),
    queryFn: () =>
      mutateData({
        url: feeEngineEndpoints.promotions.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<PromotionDto>>,
    enabled,
  });
